import { render, staticRenderFns } from "./SuspendButton.vue?vue&type=template&id=23c45801&scoped=true&"
import script from "./SuspendButton.vue?vue&type=script&lang=js&"
export * from "./SuspendButton.vue?vue&type=script&lang=js&"
import style0 from "./SuspendButton.vue?vue&type=style&index=0&id=23c45801&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c45801",
  null
  
)

export default component.exports